import axiosInstance from '../../Helpers/api_helper';

export interface UserProfileData {
  fullName?: string;
  phoneNumber?: string;
  linkedinProfile?: string;
  dateOfBirth?: string;
  profileImage?: File; // Add profileImage field
  [key: string]: string | File | undefined; // Index signature allowing any string key or File
}

export const userProfileUpdate = async (userData: UserProfileData): Promise<any> => {
  try {
    const formData = new FormData();
    
    for (const key in userData) {
      if (Object.prototype.hasOwnProperty.call(userData, key)) {
        if (key === 'profileImage' && userData[key]) {
          formData.append('profile_image_url', userData[key] as File); // Append file as profile_image_url
        } else {
          formData.append(key, userData[key] || ''); // Append other fields
        }
      }
    }

    const response = await axiosInstance.patch(
      'api/v1/participants/updateMe',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('Error updating user profile:', error.message);
    throw error;
  }
};
